import type { ErrorLike } from '@apollo/client';

import { TokenisationApiErrorMessages } from '@constants/apiErrors';
import { ValidationErrorMessages } from '@constants/forms';
import {
  BANK_ACCOUNT_DETAILS_PROCESSING_ERROR,
  INVALID_BANK_ACCOUNT_DETAILS_ERROR,
} from '@features/details/constants';
import { fetchBankToken } from '@requests/fetchBankToken';
import { BankDetails } from '@src/types/requests';

interface GetBankTokenArgs {
  bankDetails: BankDetails;
  setFieldError: (fieldName: string, message: string) => void;
  setSubmitErrors: (errors: ErrorLike[]) => void;
}

const getBankToken = async ({
  bankDetails,
  setFieldError,
  setSubmitErrors,
}: GetBankTokenArgs) => {
  try {
    const token = await fetchBankToken(bankDetails);
    return token;
  } catch (error) {
    const apolloError = error as ErrorLike;
    const { message } = apolloError;

    if (message === TokenisationApiErrorMessages.invalidBody) {
      apolloError.message = BANK_ACCOUNT_DETAILS_PROCESSING_ERROR;
    } else if (message === TokenisationApiErrorMessages.invalidValues) {
      apolloError.message = INVALID_BANK_ACCOUNT_DETAILS_ERROR;
      setFieldError('ddSortCode', ValidationErrorMessages.INVALID_SORT_CODE);
      setFieldError(
        'ddAccountNumber',
        ValidationErrorMessages.INVALID_ACCOUNT_NUMBER
      );
    }
    setSubmitErrors([apolloError]);
    return null;
  }
};

export { getBankToken };
